





































import { Component, Prop, Vue } from 'vue-property-decorator';
import User from "@/consoleapi/api/user";
import tokens from "@/authorization/tokens";

@Component
export default class UserConfirm extends Vue {
    @Prop() public name!: string;
    @Prop() public kana!: string;
    @Prop() public phoneNumber!: string;
    @Prop() public email!: string;

    //public confirm = false;

    goInputPage(){
        this.$store.dispatch('users/pushProgress', 'input');
    }

    doRegister(){
        const user = new User();
        user.setBearerToken(tokens.Tokens.BearerToken);
        user.update(tokens.AccountId, tokens.UserName, this.name, this.kana, this.phoneNumber)
            .then(response => {
                //console.log(response.data);
                this.$store.dispatch('users/pushProgress', 'result');
            }).catch(error => {
                //console.log(error.response);
            const errors = error.response.data.errors;
            let data = '';
            for (const i in errors){
                data += errors[i] + "\n";
            }
            alert(data);
        })
    }
}
